import {
  FieldType,
  IPartitionFieldsFragment,
  TimeUnit,
} from '../../../utils/apollo/graphqlSchema';

export const DAY_PARTITION_ERROR_MESSAGE =
  'Reduce the Conversion Window to less than 1 day.';

export const TIME_TO_CONVERT_PARTITION_ERROR_MESSAGE =
  'Reduce the Conversion Window to less than 1 month.';

export const isMoreThanOneDay = (timeUnit: TimeUnit, timeValue: number) => {
  switch (timeUnit) {
    case TimeUnit.Second:
      return timeValue > 86400;
    case TimeUnit.Minute:
      return timeValue > 1440;
    case TimeUnit.Hour:
      return timeValue > 24;
    case TimeUnit.Day:
      return timeValue > 1;
    case TimeUnit.Week:
    case TimeUnit.FourWeek:
    case TimeUnit.Month:
    case TimeUnit.Quarter:
    case TimeUnit.Year:
      return timeValue > 0;
    default:
      return true;
  }
};

export const isMoreThanMonth = (timeUnit: TimeUnit, timeValue: number) => {
  switch (timeUnit) {
    case TimeUnit.Second:
      return timeValue > 31 * 24 * 60 * 60;
    case TimeUnit.Minute:
      return timeValue > 31 * 24 * 60;
    case TimeUnit.Hour:
      return timeValue > 31 * 24;
    case TimeUnit.Day:
      return timeValue > 31;
    case TimeUnit.Week:
      return timeValue > 4;
    case TimeUnit.FourWeek:
      return timeValue > 1;
    case TimeUnit.Month:
      return timeValue > 1;
    case TimeUnit.Quarter:
    case TimeUnit.Year:
      return timeValue > 0;
    default:
      return true;
  }
};

export const isDayPartition = (partition: IPartitionFieldsFragment) =>
  partition.__typename === 'FieldPartition' &&
  partition.field.type === FieldType.Date;
